import type { ProgramPageBaseWithTestimonials } from "@classes-service-types/program-page-base-with-testimonials";
import { useQuery } from "@tanstack/vue-query";
import type { ComputedRef, Ref } from "vue";
import { computed, unref } from "vue";
import { learningServiceRequest } from "@/services/utils";

type ProgramPageIdInput = Ref<string | undefined> | ComputedRef<string | undefined> | string;

export const programPageByIdQueryKey = (programPageId: string) => ["getProgramPageById", programPageId] as const;

export const useGetProgramPageById = (programPageId: ProgramPageIdInput) => {
  const enabled = computed(() => Boolean(unref(programPageId)));
  const queryKey = computed(() => {
    const id = unref(programPageId);
    const normalized = Array.isArray(id) ? id[0] : id;
    return programPageByIdQueryKey(normalized ?? "");
  });

  return useQuery<ProgramPageBaseWithTestimonials, Error, ProgramPageBaseWithTestimonials>({
    enabled: enabled,
    queryKey: queryKey,
    queryFn: async (): Promise<ProgramPageBaseWithTestimonials> => {
      const response = await learningServiceRequest({
        method: "get",
        url: `/programming/program_pages/${unref(programPageId)}`,
        failureMessage: "Error loading program page",
      });
      return response?.data?.data?.items;
    },
  });
};
